
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { usePricingRefresh } from '@/hooks/usePricingRefresh';
import { LineItemMarkupTier } from '@/types/line-item-markup-tiers';

interface PricingRefreshButtonProps {
  lineItemId: string;
  currentBaseCost: number;
  categoryId?: string;
  companyId?: string;
  customTiers?: LineItemMarkupTier[];
  useCustomTiers?: boolean;
  onPricingRefreshed?: () => void;
}

const PricingRefreshButton: React.FC<PricingRefreshButtonProps> = ({
  lineItemId,
  currentBaseCost,
  categoryId,
  companyId,
  customTiers,
  useCustomTiers,
  onPricingRefreshed
}) => {
  const { 
    isRefreshing, 
    showPricingPreview 
  } = usePricingRefresh({
    lineItemId,
    currentBaseCost,
    categoryId,
    companyId,
    customTiers,
    useCustomTiers
  });

  const handleRefreshClick = async () => {
    const preview = await showPricingPreview();
    if (preview) {
      // The preview modal will be handled by the parent component
      onPricingRefreshed?.();
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleRefreshClick}
      disabled={isRefreshing}
      className="flex items-center gap-2"
    >
      <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
      Refresh Pricing
    </Button>
  );
};

export default PricingRefreshButton;
